import dayjs from 'dayjs'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      selectedEvent: false,
      selectedEventId: null,
      calendarCategories: {
        MAINTENENCE: 0,
        CALL: 1,
        AUTOMATICA: 2,
        GUARANTEE: 3,
        CONTRACT: 5,
        OTHER: 4,
        STARTUP: 6
      },
      calendarStatuses: {
        DELETED: 'deleted',
        PAST: 'past',
        FUTURE: 'future'
      },
      calendarDeleteReasons: {
        UNKNOWN: 0,
        CANCELLED: 1,
        NO_SHOW: 2
      },
      contractIntervals: {
        NONE: 0,
        MONTHLY: 1,
        QUARETRLY: 2
      },
      objectTypes: {
        REGULAR: 0,
        CONTRACT: 1
      }
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isAdmin', 'isSecretary', 'isTechnic']),
    calendarCategoryOptions () {
      return [{
        value: this.calendarCategories.CALL,
        text: 'Valve'
      }, {
        value: this.calendarCategories.MAINTENENCE,
        text: 'Hooldus'
      }, {
        value: this.calendarCategories.AUTOMATICA,
        text: 'Automaatika'
      }, {
        value: this.calendarCategories.GUARANTEE,
        text: 'Garantii'
      }, {
        value: this.calendarCategories.CONTRACT,
        text: 'Lepinguline'
      }, {
        value: this.calendarCategories.STARTUP,
        text: 'Käivitamine'
      }, {
        value: this.calendarCategories.OTHER,
        text: 'Muu'
      }]
    },
    calendarStatusOptions () {
      return [{
        value: this.calendarStatuses.FUTURE,
        text: 'Tulevikus'
      }, {
        value: this.calendarStatuses.PAST,
        text: 'Lõppenud'
      }, {
        value: this.calendarStatuses.DELETED,
        text: 'Kustutatud'
      }]
    },
    calendarDeleteReasonOptions () {
      return [{
        value: this.calendarDeleteReasons.UNKNOWN,
        text: 'Muu'
      }, {
        value: this.calendarDeleteReasons.CANCELLED,
        text: 'Klient tühistas'
      }, {
        value: this.calendarDeleteReasons.NO_SHOW,
        text: 'Klient ei ilmunud'
      }]
    },
    contractIntervalOptions () {
      return [{
        value: this.contractIntervals.NONE,
        text: 'Puudub'
      }, {
        value: this.contractIntervals.MONTHLY,
        text: 'Kord kuus'
      }, {
        value: this.contractIntervals.QUARETRLY,
        text: 'Kord kvartalis'
      }]
    },
    objectTypeOptions () {
      return [{
        value: this.objectTypes.REGULAR,
        text: 'Tavaline'
      }, {
        value: this.objectTypes.CONTRACT,
        text: 'Lepinguline'
      }]
    },
    reactionTimeOptions () {
      return Array.from({ length: 25 }, (_, i) => i).map(i => ({
        value: i,
        text: i === 0 ? 'Puudub' : (i == 1 ? '1 Tund' : i + ' Tundi')
      }))
    }
  },
  methods: {
    eventPeriod (event) {
      return dayjs(event.startDate).format('HH:mm') + ' - ' + dayjs(event.endDate).format('HH:mm @ YYYY-MM-DD')
    },
    eventColor (event) {
      switch (event.status) {
        case 'deleted':
          return 'red'
        case 'past':
          return 'green'
        case 'future':
          return 'primary'
      }
    },
    viewEvent (event) {
      this.selectedEventId = event.id
      this.selectedEvent = true
    },
    canEdit (type, model) {
      switch (type) {
        // Technicians edit any object and any calendar entry since 2026-10-07.
        case 'object':
        case 'event':
          return this.isAdmin || this.isSecretary || this.isTechnic || (model && model.adder && this.user && model.adder.id === this.user.userId)
        case 'client':
          return this.isAdmin || this.isSecretary
        default:
          return this.isAdmin
      }
    },
    canDelete (type, model) {
      switch (type) {
        // A device row on an object (model): the office, or whoever entered
        // the object. Editing any object did not widen this.
        case 'device':
          return this.isAdmin || this.isSecretary || (model && model.adder && this.user && model.adder.id === this.user.userId)
        case 'event':
          return this.isAdmin || this.isSecretary || (model && model.adder && this.user && model.adder.id === this.user.userId)
        default:
          return this.isAdmin
      }
    },
    calendarCategoryById (id) {
      return this.calendarCategoryOptions.find(item => item.value === id) || { text: '-' }
    },
    calendarDeleteReasonById (id) {
      return this.calendarDeleteReasonOptions.find(item => item.value === id) || { text: '-' }
    },
    contractIntervalOptionById (id) {
      return this.contractIntervalOptions.find(item => item.value === id) || { text: '-' }
    },
    reactionTimeOptionById (id) {
      return this.reactionTimeOptions.find(item => item.value === id) || { text: '-' }
    }
  }
}

